module.exports = __webpack_public_path__ + "85cfc7bbada584a3198f06f4d9707a77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/DiagnosticsWhite.jpg
// module id = 1293
// module chunks = 0